export const avatarDB = {
	FreeCodeCamp:
		"https://yt3.ggpht.com/ytc/AKedOLRyPFojwY3CXV5ks5TwPrt2VifQn-nYNfkgLvVPkw=s176-c-k-c0x00ffffff-no-rj-mo",
	Edureka:
		"https://yt3.ggpht.com/OtB--dcR_oNUZUaUsuyk2ShT5nFYjEcj9Yxx50-Nner03vXKt4IWXtP--JrnSGQbwRSHYuVb38g=s88-c-k-c0x00ffffff-no-rj",
	Intellipaat:
		"https://yt3.ggpht.com/sm9KjocCAAXBPB5gyBMk24j6ZWk2t8nOw2ID_00u5fiS2qBH3MIiphaklt5wq91KeSCHwlCz=s88-c-k-c0x00ffffff-no-rj",
	TechWiser:
		"https://yt3.ggpht.com/l350nysbhW3iDxI5YoelK4c-bhNzoQ0Vpg6Qt1vZ0Cweu3PBiPsF0TBZ5ZQtI8dK1KspCMq7xA=s88-c-k-c0x00ffffff-no-rj",
	Fireship:
		"https://yt3.ggpht.com/ytc/AKedOLR5CDv14gL4DQ7I4gxIlBMY6u-CNsq2qfeev48R2g=s48-c-k-c0x00ffffff-no-rj",
	TheLinuxExperiment:
		"https://yt3.ggpht.com/ytc/AKedOLSJ1evct2-MER0f0xFqcc0j42qnUgwp2ohcjK3I=s48-c-k-c0x00ffffff-no-rj",
	ChrisTitusTech:
		"https://yt3.ggpht.com/ytc/AKedOLTE8sCvbu2Gebpjlu_bX4YJxwFbnKai7m8zxWD05g=s48-c-k-c0x00ffffff-no-rj",
	LinuxScoop:
		"https://yt3.ggpht.com/q9XP-4QBx0Cehl9kppjIEp2pA14gATTjf9GQ_abuobWvkLBAT7MuDqxpbUezoQlddEwhW9T7=s48-c-k-c0x00ffffff-no-rj",
	DistroTube:
		"https://yt3.ggpht.com/3aTiR8-i48HnwXZKBacKe_niYg1zmIH2BFv_OqQotxqu3eurYH64sKF2YITmj41Y1p5iPYdaLQ=s48-c-k-c0x00ffffff-no-rj",
};
